"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _context;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class VehicleLink extends _AuComponent.default {
  static propTypes = {
    vehicleId: T.string.isRequired,
    className: T.string,
    actions: T.object.isRequired
  };
  handleOnClick = (0, _bind.default)(_context = this.handleOnClick).call(_context, this);
  handleOnClick(e) {
    e.preventDefault();
    this.props.actions.openVehicleDetails(this.props.vehicleId, this.props.selectedTab);
  }
  render() {
    const {
      className,
      children,
      vehicleId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: className,
      onClick: this.handleOnClick,
      to: `/vehicles/${vehicleId}`
    }, children);
  }
}
exports.default = VehicleLink;